import{jsxs as e,jsx as t,Fragment as o}from"react/jsx-runtime";import{ChromeContainer as i}from"@exo/frontend-features-chrome-logic";import{getChromeConfig as n}from"@exo/frontend-features-chrome-ui";import{useHistory as r,useLocation as a,useParams as l,Route as s}from"react-router-dom";import{Link as d,Input as c,Button as g,ButtonSecondary as u,PageNotFound as m,ChromeWrapper as p}from"exo-frontend-remote-components";import{AppShellSwitch as f}from"@exo/frontend-common-app-shell";import h from"styled-components";import{agroTheme as b}from"exo-frontend-remote-theme";import v,{useMemo as w,useState as x,useEffect as y,useCallback as $}from"react";import{gql as C,useLazyQuery as P,useQuery as z}from"@apollo/client";import k from"universal-cookie";import{TagManagerUtils as N,ActionType as T,UserLoggedStatus as I}from"exo-frontend-remote-utils";import{useSessionContext as S}from"@exo/frontend-common-session-context";import{Misuse32 as F,Rss20 as D,Information24 as A,ChevronLeft32 as E,ChevronRight32 as L,Share16 as G,ArrowLeft16 as B,Blog24 as M,Bullhorn24 as _,TagGroup20 as j,ChevronUp24 as W,Flash24 as R,Rss24 as O}from"@carbon/icons-react";import{useNotificationContext as q}from"@exo/frontend-common-notification";import{Helmet as H}from"react-helmet";import{generateUUID as V}from"three/src/math/MathUtils";var U="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function Y(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}var K={exports:{}},X="undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},J=void 0!==X?X:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};function Q(){throw new Error("setTimeout has not been defined")}function Z(){throw new Error("clearTimeout has not been defined")}var ee=Q,te=Z;function oe(e){if(ee===setTimeout)return setTimeout(e,0);if((ee===Q||!ee)&&setTimeout)return ee=setTimeout,setTimeout(e,0);try{return ee(e,0)}catch(t){try{return ee.call(null,e,0)}catch(t){return ee.call(this,e,0)}}}"function"==typeof J.setTimeout&&(ee=setTimeout),"function"==typeof J.clearTimeout&&(te=clearTimeout);var ie,ne=[],re=!1,ae=-1;function le(){re&&ie&&(re=!1,ie.length?ne=ie.concat(ne):ae=-1,ne.length&&se())}function se(){if(!re){var e=oe(le);re=!0;for(var t=ne.length;t;){for(ie=ne,ne=[];++ae<t;)ie&&ie[ae].run();ae=-1,t=ne.length}ie=null,re=!1,function(e){if(te===clearTimeout)return clearTimeout(e);if((te===Z||!te)&&clearTimeout)return te=clearTimeout,clearTimeout(e);try{return te(e)}catch(t){try{return te.call(null,e)}catch(t){return te.call(this,e)}}}(e)}}function de(e,t){this.fun=e,this.array=t}de.prototype.run=function(){this.fun.apply(null,this.array)};function ce(){}var ge=ce,ue=ce,me=ce,pe=ce,fe=ce,he=ce,be=ce;var ve=J.performance||{},we=ve.now||ve.mozNow||ve.msNow||ve.oNow||ve.webkitNow||function(){return(new Date).getTime()};var xe=new Date;var ye={nextTick:function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var o=1;o<arguments.length;o++)t[o-1]=arguments[o];ne.push(new de(e,t)),1!==ne.length||re||oe(se)},title:"browser",browser:!0,env:{},argv:[],version:"",versions:{},on:ge,addListener:ue,once:me,off:pe,removeListener:fe,removeAllListeners:he,emit:be,binding:function(e){throw new Error("process.binding is not supported")},cwd:function(){return"/"},chdir:function(e){throw new Error("process.chdir is not supported")},umask:function(){return 0},hrtime:function(e){var t=.001*we.call(ve),o=Math.floor(t),i=Math.floor(t%1*1e9);return e&&(o-=e[0],(i-=e[1])<0&&(o--,i+=1e9)),[o,i]},platform:"browser",release:{},config:{},uptime:function(){return(new Date-xe)/1e3}},$e={exports:{}};(function(){var e,t,o,i,n,r;"undefined"!=typeof performance&&null!==performance&&performance.now?$e.exports=function(){return performance.now()}:null!=ye&&ye.hrtime?($e.exports=function(){return(e()-n)/1e6},t=ye.hrtime,i=(e=function(){var e;return 1e9*(e=t())[0]+e[1]})(),r=1e9*ye.uptime(),n=i-r):Date.now?($e.exports=function(){return Date.now()-o},o=Date.now()):($e.exports=function(){return(new Date).getTime()-o},o=(new Date).getTime())}).call(U);for(var Ce=$e.exports,Pe="undefined"==typeof window?U:window,ze=["moz","webkit"],ke="AnimationFrame",Ne=Pe["request"+ke],Te=Pe["cancel"+ke]||Pe["cancelRequest"+ke],Ie=0;!Ne&&Ie<ze.length;Ie++)Ne=Pe[ze[Ie]+"Request"+ke],Te=Pe[ze[Ie]+"Cancel"+ke]||Pe[ze[Ie]+"CancelRequest"+ke];if(!Ne||!Te){var Se=0,Fe=0,De=[],Ae=1e3/60;Ne=function(e){if(0===De.length){var t=Ce(),o=Math.max(0,Ae-(t-Se));Se=o+t,setTimeout((function(){var e=De.slice(0);De.length=0;for(var t=0;t<e.length;t++)if(!e[t].cancelled)try{e[t].callback(Se)}catch(e){setTimeout((function(){throw e}),0)}}),Math.round(o))}return De.push({handle:++Fe,callback:e,cancelled:!1}),Fe},Te=function(e){for(var t=0;t<De.length;t++)De[t].handle===e&&(De[t].cancelled=!0)}}K.exports=function(e){return Ne.call(Pe,e)},K.exports.cancel=function(){Te.apply(Pe,arguments)},K.exports.polyfill=function(e){e||(e=Pe),e.requestAnimationFrame=Ne,e.cancelAnimationFrame=Te};var Ee=Y(K.exports);const Le=h.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  gap: 1rem;
  justify-content: space-between;
  //padding: 1rem;
  /* flex-direction: column; */

  .main-title {
    font-size: ${b.fontSize14};
    font-weight: 600;
  }

  @media (max-width: 1055px) {
    grid-template-columns: 1fr;

    .more-news-button {
      width: 100%;
    }
  }
`,Ge=h.h1`
  font-size: ${b.fontSize10};
  font-weight: ${b.fontWeight02};
  margin-top: 1rem;
  margin-bottom: 3.125rem;

  @media (max-width: 671px) {
    font-size: ${b.fontSize04};
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
`,Be=h.span`
  font-size: ${b.fontSize10};
  font-weight: ${b.fontWeight02};
  margin-top: 1rem;
  margin-bottom: 3.125rem;

  @media (max-width: 671px) {
    font-size: ${b.fontSize04};
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
`;h.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  input {
    width: 13rem;
  }

  button {
    width: 4.68rem;
    min-height: 0;
    height: 2.375rem;
    background-image: none;
    background-color: ${b.bg01};

    &:hover {
      background-color: ${b.bg01};
      filter: brightness(0.75);
    }
  }
`;const Me=h.div`
  width: 100%;
  .main-title {
    display: flex;
    gap: 0.5rem;
    font-size: ${b.fontSize14};
    font-weight: ${b.fontWeight03};

    @media (max-width: 671px) {
      font-size: ${b.fontSize03};
    }
  }
`,_e=h.a`
  display: flex;
  border: none;
  font-size: ${b.fontSize14};
  color: ${b.colorInfo};
  font-weight: ${b.fontWeight03};
  background-color: transparent !important;
  transition: 250ms;
  width: fit-content;
  text-transform: capitalize;
  cursor: pointer;

  :hover {
    text-decoration: underline;
    filter: brightness(0.8);
  }

  @media (max-width: 671px) {
    font-size: ${b.fontSize03};
  }
`,je=h.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (max-width: 671px) {
    margin-top: 0.5rem;
  }
`,We=h.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;

  @media (max-width: 671px) {
    gap: 1.5rem;

    .more-news-button {
      width: 100%;
      max-width: 100%;
    }
  }
`,Re=h.div`
  display: none;

  @media (max-width: 671px) {
    margin-top: 1rem;
    background-color: ${b.color16};
    height: 1px;
    width: 100%;
    display: inherit;
  }
`,Oe=h.div`
  display: none;

  @media (max-width: 671px) {
    background-color: ${b.color16};
    height: 1px;
    width: 100%;
    margin-bottom: 1rem;
    display: inherit;
  }
`;h.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 4rem;

  @media (max-width: 672px) {
    margin-top: 2rem;
  }
`;const qe=h.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: fit-content;
  width: 100%;

  padding: 1rem;

  p {
    font-size: ${b.fontSize01};
    font-weight: ${b.fontWeight04};
    color: ${b.bg04};
  }

  .title {
    font-size: ${b.fontSize04};
    font-weight: ${b.fontWeight03};
    color: ${b.bg04};
  }

  svg {
    fill: ${b.colorError};
  }
`;h.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 1rem;
  background-color: ${b.bg14};
  border: 1px solid ${b.color06};
  border-radius: 0.5rem;

  .blue-icon {
    fill: ${b.colorInfo};
  }
  p {
    font-size: ${b.fontSize02};
    font-weight: ${b.fontWeight03};
    color: ${b.bg04};
  }

  svg {
    fill: ${b.colorError};
  }

  @media (max-width: 672px) {
    width: 100%;
  }
`;const He=h.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;

  opacity: 0;
  pointer-events: none;

  transition: 500ms;

  .spinner {
    display: block;
    border-top: 6px solid ${b.bg01};
    border-left: 6px solid ${b.bg01};
    border-right: 6px solid ${b.bg01};
    border-bottom: 6px solid transparent;
    border-radius: 100%;
    min-height: 48px;
    min-width: 48px;
    animation: spin 600ms linear infinite;
  }

  p {
    font-size: ${b.fontSize02};
    font-weight: ${b.fontWeight03};
    color: ${b.bg03};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  &.show {
    opacity: 1;
    pointer-events: all;
  }
`,Ve=h.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 672px) {
    flex-direction: column;
    margin-bottom: 1rem;
  }
`,Ue=h.div`
  gap: 1rem;
  max-height: 5.5rem;

  display: grid;
  width: 100%;
  grid-template-columns: 1.2fr 2fr;

  .news-image {
    object-fit: cover;
    border-radius: 0.5rem;
    height: 5rem;
    width: 100%;
    cursor: pointer;
  }

  @media (min-width: 672px) {
    .news-image {
      border-radius: 0.5rem;
      height: 5.5rem;
      width: 100%;
    }

    ${e=>(null==e?void 0:e.large)&&"\n            max-height: 12.5rem;\n\n            .news-image {\n                height: 12.5rem;\n            }\n        "}
  }
`,Ye=h.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  font-weight: 400;
  color: ${b.color09};
  padding: 0.25rem 0;

  .category-title {
    color: ${b.colorInfo};
    font-size: 0.875rem;
    font-weight: bold;

    :hover {
      text-decoration: underline;
    }
  }

  .news-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: ${b.color04};
    line-height: 1.125rem;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;

    :hover {
      text-decoration: underline;
    }
  }

  .news-description {
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: ${b.color10};
    overflow: hidden;
    margin-bottom: 0.5rem;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }

  @media (max-width: 671px) {
    .news-title {
      overflow: hidden;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      display: -webkit-box;
    }

    .date,
    .news-description {
      display: none;
    }
  }

  @media (min-width: 672px) {
    ${e=>(null==e?void 0:e.large)&&"\n            justify-content: space-around;\n\n            .category-title {\n                font-size: 1rem;\n            }\n\n            .news-title {\n                font-size: 1.25rem;\n                line-height: 1.625rem;\n                overflow: inherit;\n            }\n        "}
  }
`,Ke=e=>{if(!e)return;const[t,o,i]=e.split("T")[0].split("-");return`${i}/${o}/${t}`},Xe=e=>{if(!e)return;const[t,o,i]=e.split("T")[0].split("-"),[n,r]=e.split("T")[1].split(":");return`${i}/${o}/${t} às ${n}:${r}h`};const Je=({large:o,news:i,pageType:n,category:a})=>{var l,s,c;const g=r();return e(Ue,{large:o,children:[t("img",{src:i.urlMiniatura,alt:a,title:a,className:"news-image",loading:"lazy",onClick:()=>{var e;return g.push(`/${n}/${null===(e=i.categoria)||void 0===e?void 0:e.slug}/${i.slug}`)}}),e(Ye,{large:o,children:[t(d,{className:"category-title",onClick:()=>{var e;return g.push(`/${n}/${null===(e=i.categoria)||void 0===e?void 0:e.slug}`)},children:null===(s=null===(l=i.categoria)||void 0===l?void 0:l.titulo)||void 0===s?void 0:s.toLocaleUpperCase()}),t("h3",{className:"news-title",title:null===(c=i.categoria)||void 0===c?void 0:c.titulo,onClick:()=>{var e;return g.push(`/${n}/${null===(e=i.categoria)||void 0===e?void 0:e.slug}/${i.slug}`)},children:i.titulo}),o&&t("p",{className:"news-description",children:i.resumo}),o&&t("span",{className:"date",children:Ke(i.createdAt)})]})]})},Qe=C`
  query GetNewsFeatureFlag($featureName: String) {
    getFeatureFlag(featureName: $featureName) {
      enabled
    }
  }
`,Ze=C`
  query GetBlogFeatureFlag {
    getPostStaticContent {
      enabled
    }
  }
`,et=C`
  query GetFeatureFlag($featureName: String) {
    getFeatureFlag(featureName: $featureName) {
      featureName
      pageReference
      description
      enabled
    }
  }
`,tt=()=>{const[e,{loading:t,error:o,data:i}]=P(et,{fetchPolicy:"no-cache"});return{getFeatureFlag:e,loading:t,error:o,data:i}};C`
  query GetDashboardDataContent {
    getDashboardDataContent {
      newDashboard {
        crmBanner {
          enabled
          crmBannerContent {
            urlBannerPortal
            urlBannerMobile
            description
            redirectUrl
            redirectMobile
            isWebview
          }
        }
        creditLimitCard {
          enabled
        }
        weatherCard {
          enabled
        }
        orders {
          enabled
        }
        priceMarket {
          enabled
          header {
            title
            icon
          }
          content {
            futureMarket {
              title
              enabled
              showList
              showGraphic
            }
            quotation {
              title
              enabled
            }
          }
          footer {
            text
          }
        }
        newsPortal {
          enabled
        }
        marketplacePartners {
          enabled
          title
          subtitle
        }
        whatsappButton {
          enabled
          hintText
          phoneNumber
          url
        }
        marketplaceCategories {
          enabled
          title
          icon
          url
          buttonText
        }
      }
    }
  }
`;const ot=({category:e,slug:i,getPosts:{data:n,error:r,loading:l,called:s,getPosts:d}})=>{var c,g;const[u,m]=x(5),[p,f]=x(""),[h,b]=x(""),[v,C]=x(void 0),[z,k]=x(""),[N,T]=x(!1),[I,S]=x(!1),[F,D]=x(!1),[A,E]=x(!1),[L,G]=x(!1),[B,M]=x(!1),[_,j]=x(null),W=a(),R=w((()=>(e=>e?e.toLowerCase().split("/")[1]:"")(W.pathname)),[W]),O=w((()=>{if(W){return"null"===W.pathname.split("/")[2]}return!0}),[W]),{getNewsFeatureFlag:q,loading:H,error:V,data:U,called:Y}=((e,t)=>{const[o,{loading:i,error:n,data:r,called:a}]=P("noticias"===t?Qe:Ze,{variables:{featureName:e},fetchPolicy:"no-cache"});return{getNewsFeatureFlag:o,loading:i,error:n,data:r,called:a}})("newsChannel",R),{getFeatureFlag:K,data:X,error:J,loading:Q}=tt();y((()=>{q(),K({variables:{featureName:"newsletter"}})}),[]);const Z=(null===(g=null===(c=null==n?void 0:n.getPosts.meta)||void 0===c?void 0:c.pagination)||void 0===g?void 0:g.total)||0;y((()=>{-1!==v&&(S(!1),E(!1),M(!1)),s&&(d({variables:{page:1,pageSize:5,categoryId:v,route:R}}),m(5))}),[v]);const ee=$((()=>!l&&(null==n?void 0:n.getPosts.data)&&n.getPosts.data.length>0?e||i?n.getPosts.data.map((o=>t(Je,{news:o,pageType:R,category:e,large:!0},o.id))):n.getPosts.data.map((i=>{var n;return _!==(null===(n=i.id)||void 0===n?void 0:n.toString())?t(Je,{news:i,pageType:R,category:e,large:!0},i.id):t(o,{})})):t(o,{})),[n,l,e,i,_]),te=w((()=>l||N||F||L||Q),[l,N,F,L,Q]),oe=w((()=>!!r||I||A||B||Boolean(J)||O),[r,I,A,B,J,O]),ie=w((()=>{let e=!1;if(Y&&!H&&!V)if("noticias"===R){const t=U;e=t&&t.getFeatureFlag&&t.getFeatureFlag[0].enabled||!1}else{const t=U;e=t&&t.getPostStaticContent&&t.getPostStaticContent.enabled||!1}return e}),[Y,U,V,H,R]),ne=w((()=>!Q&&!J&&X&&X.getFeatureFlag&&X.getFeatureFlag[0].enabled||!1),[X,J,Q]);return{onGetOmittID:j,blogOrNewsHandler:{pageTitle:"blog"===R?"Blog":"Notícias do mercado",pageType:R},mainPageActions:{isFeatureFlagEnabled:ie,isFeatureFlagLoading:H,isFeatureFlagCalled:Y,states:{hasError:oe,isLoading:te},onLoadMoreNews:function(){if(n&&!l){const e=u<Z?u+5:Z;m(e),d({variables:{page:1,pageSize:e,categoryId:v,route:R}})}},getNewsComponent:ee},pageElementsHandler:{hasCarousel:!e&&!i,hasDetailedNews:!(!e||!i),hasCategoryFiltered:!(!e||i),hasMoreNewsButton:!!(u<Z&&(null==n?void 0:n.getPosts.data)),hasNewsletter:ne},pageActionHandler:{pagination:{paginationIndex:u,setPaginationIndex:m},breadcrumb:{breadcrumbTitle:p,setBreadcrumbTitle:f},resumed:{newsResumed:h,setNewsResumed:b},category:{id:{categoryID:v,setCategoryID:C},title:{categoryTitle:z,setCategoryTitle:k}}},pageCallbackHandlers:{details:{loading:{detailsLoading:N,setDetailsLoading:T},error:{detailsError:I,setDetailsError:S}},similar:{loading:{similarLoading:F,setSimilarLoading:D},error:{similarError:A,setSimilarError:E}},categories:{loading:{categoriesLoading:L,setCategoriesLoading:G},error:{categoriesError:B,setCategoriesError:M}}}}},it=C`
  query GetPosts(
    $page: Int!
    $pageSize: Int!
    $route: String!
    $categoryId: Int
    $sort: NewsSort
  ) {
    getPosts(
      page: $page
      pageSize: $pageSize
      route: $route
      categoryId: $categoryId
      sort: $sort
    ) {
      data {
        id
        codigoAgroLink
        antetitulo
        titulo
        fonte
        dataHoraAgroLink
        resumo
        texto
        urlBanner
        urlBannerMobile
        urlMiniatura
        visualizacoes
        disponivelParaLeitura
        disponivelAreaDeslogada
        createdAt
        updatedAt
        slug
        categoria {
          id
          slug
          titulo
          createdAt
          updatedAt
          disponivelAreaDeslogada
        }
      }
      meta {
        pagination {
          page
          pageSize
          pageCount
          total
        }
      }
    }
  }
`;function nt(e,t,o,i){return new(o||(o=Promise))((function(n,r){function a(e){try{s(i.next(e))}catch(e){r(e)}}function l(e){try{s(i.throw(e))}catch(e){r(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof o?t:new o((function(e){e(t)}))).then(a,l)}s((i=i.apply(e,t||[])).next())}))}var rt;function at(e){(e&&e.length<1||!e)&&console.error("Invalid tagging object.");const t=S();function o(e,t,o){var i;if(o){const n=t;"element"===e?n.nome_elemento=o:"screen"===e&&(n.tela=null===(i=n.tela)||void 0===i?void 0:i.replace("{{override}}",o))}return t}return{callTagManager:function(i,n,r){return nt(this,void 0,void 0,(function*(){if(e){const a=e.find((e=>e.tagId===i));if(a)return"INTERACT"===a.tagParams.GTAGFunctionType?function(e,i,n){const r=o("element",Object.assign({},e),n);N.interact(T.Click,r.local_acao||"",r.nome_elemento||"",r.fluxo||"",I.LoggedIn,r.tela||"",null,{userId:N.getUserId(t)},null,i?[{fieldName:"title",fieldValue:i}]:void 0)}(a.tagParams,a.tagParams.title,n):function(e,i,n){const r=o("screen",Object.assign({},e),n);N.pageview(T.PageView,r.fluxo||"",N.getUserStatus(t),r.tela||"",r.local_acao||"web",null,{userId:N.getUserId(t)},void 0,null,i?[{fieldName:"title",fieldValue:i}]:void 0)}(a.tagParams,a.tagParams.title,r)}return console.error("There is no tagging object created for that type of product.")}))}}}"function"==typeof SuppressedError&&SuppressedError,function(e){e.eventData="Event_Data",e.screenData="Screen_Data"}(rt||(rt={}));const lt={news:[{tagId:"pageLoad",tagParams:{GTAGFunctionType:"PAGE_VIEW",event:rt.screenData,fluxo:"noticias",tela:"e-agro/noticias/noticias-do-mercado",local_acao:"web",title:"noticias"}},{tagId:"categoryClick",tagParams:{GTAGFunctionType:"INTERACT",event:rt.eventData,fluxo:"noticias",tela:"e-agro/noticias/noticias-do-mercado",local_acao:"web",nome_elemento:"{{override}}",title:"categorias"}},{tagId:"newsletterClick",tagParams:{GTAGFunctionType:"INTERACT",event:rt.eventData,fluxo:"noticias",tela:"e-agro/noticias/noticias-do-mercado",local_acao:"web",nome_elemento:"ok",title:"receba-noticias-por-email"}},{tagId:"loadMoreNews",tagParams:{GTAGFunctionType:"INTERACT",event:rt.eventData,fluxo:"noticias",tela:"e-agro/noticias/noticias-do-mercado",local_acao:"web",nome_elemento:"carregar-mais-noticias",title:"publicadas-recentemente"}},{tagId:"detailsLoad",tagParams:{GTAGFunctionType:"PAGE_VIEW",event:rt.screenData,fluxo:"noticias",tela:"e-agro/noticias/noticias-do-mercado/{{override}}/noticia",local_acao:"web",title:"noticias"}}],blog:[{tagId:"pageLoad",tagParams:{GTAGFunctionType:"PAGE_VIEW",event:rt.screenData,fluxo:"noticias",tela:"e-agro/blog/noticias-do-mercado",local_acao:"web",title:"noticias"}},{tagId:"categoryClick",tagParams:{GTAGFunctionType:"INTERACT",event:rt.eventData,fluxo:"noticias",tela:"e-agro/blog/noticias-do-mercado",local_acao:"web",nome_elemento:"{{override}}",title:"categorias"}},{tagId:"newsletterClick",tagParams:{GTAGFunctionType:"INTERACT",event:rt.eventData,fluxo:"noticias",tela:"e-agro/blog/noticias-do-mercado",local_acao:"web",nome_elemento:"ok",title:"receba-noticias-por-email"}},{tagId:"loadMoreNews",tagParams:{GTAGFunctionType:"INTERACT",event:rt.eventData,fluxo:"noticias",tela:"e-agro/blog/noticias-do-mercado",local_acao:"web",nome_elemento:"carregar-mais-noticias",title:"publicadas-recentemente"}},{tagId:"detailsLoad",tagParams:{GTAGFunctionType:"PAGE_VIEW",event:rt.screenData,fluxo:"noticias",tela:"e-agro/blog/noticias-do-mercado/{{override}}/noticia",local_acao:"web",title:"noticias"}}]},st=()=>e(qe,{children:[t(F,{}),t("p",{className:"title",children:"Não foi possível carregar essa informação"}),t("p",{children:"Recarregue a página ou tente novamente mais tarde."})]}),dt=h.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: auto;
  /* max-width: 24.12rem; */
  max-width: 100%;

  padding: 1rem;

  background-color: ${b.bg14};
  border: 1px solid ${b.color06};
  border-radius: 0.5rem;

  .news-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: ${b.color04};
  }

  svg {
    color: ${b.colorInfo};
  }

  span {
    color: ${b.colorInfo};
  }
`,ct=h.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  input {
    width: 13rem;
  }

  button {
    width: 4.68rem;
    min-height: 0;
    height: 2.375rem;
    background-image: none;
    background-color: ${b.bg01};

    &:hover {
      background-color: ${b.bg01};
      filter: brightness(0.75);
    }
  }
`,gt=({onClickGtm:o})=>{const[i,n]=x(!1);return e(dt,{children:[t(D,{}),t("span",{className:"news-title",children:"Receba notícias por e-mail"}),i?t("span",{children:"Cadastro realizado com sucesso!"}):e(ct,{children:[t(c,{placeholder:"Seu e-mail"}),t(g,{label:"OK",onClick:()=>{n(!0),o()}})]})]})},ut=h.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  //height: 400px;

  overflow: hidden;

  /* @media (max-width: 671px) {
    height: fit-content;
  } */
`,mt=h.div`
  position: relative;
  width: 100%;
  height: fit-content;

  border-radius: 0.5rem;
  overflow: hidden;

  &:hover > .description-container > .description {
    text-decoration: underline;
  }

  .change-news-button {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    transition: 500ms;
    z-index: 10;
    border-radius: 100%;
    height: 32px;
    width: 32px;
    outline: none;
    cursor: pointer;

    :hover {
      background-color: #00000041;
    }

    svg {
      fill: ${b.bg03};
    }

    /* @media (max-width: 671px) {
      display: none;
    } */
  }

  .left {
    left: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
  }

  .right {
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
  }

  .description-container {
    position: absolute;
    width: 70%;
    left: 1.5rem;
    bottom: 1rem;
    z-index: 10;
    color: ${b.bg03};
    font-size: ${b.fontSize14};
    font-weight: ${b.fontWeight03};
    pointer-events: none;
  }

  .identifier {
    width: fit-content;
    font-size: ${b.fontSize01};
    padding: 0.225rem 0.5rem;
    border-radius: 0.5rem;
    font-weight: ${b.fontWeight03};
    background-color: ${b.colorInfo};
  }

  .description {
    color: ${b.bg03};
    font-size: ${b.fontSize14};
    font-weight: ${b.fontWeight03};
    pointer-events: none;
  }

  @media (max-width: 680px) {
    .description-container {
      width: 90%;
      left: 1rem;
    }

    .description {
      font-size: ${b.fontSize02};
    }

    .identifier {
      font-size: ${b.fontSize07};
    }
  }
`,pt=h.div`
  position: relative;
  display: flex;
  width: 100%;
  height: fit-content;
  transition: 500ms;

  transform: ${e=>`translateX(${"R"===e.$dir?-1*e.$slideIndex*100:100*e.$slideIndex}%);`};

  /*   @media (max-width: 680px) {
    height: 200px;
  } */
`,ft=h.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem;

  .dot-navigator {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    border: none;
    cursor: pointer;
    background-color: ${b.color16};
    transition: 500ms;

    :hover {
      filter: brightness(0.8);
    }
  }

  .selected {
    background-color: ${b.bg01};
  }

  .more-news-button {
    position: absolute;
    bottom: 1rem;
    right: 0;
    font-size: ${b.fontSize01};
    font-weight: ${b.fontWeight03};
    color: ${b.bg01};
    border: none;
    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  }
`,ht=h.img`
  width: 100%;
  min-width: 100%;

  object-fit: fill;

  //aspect-ratio: 3 / 2;
  height: 400px;
  border: none;

  filter: brightness(0.5);
  cursor: pointer;

  @media (max-width: 680px) {
    height: 238px;
  }
`,bt=h.section`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: ${b.bg14};
  border: 1px solid ${b.color16};
  border-radius: 0.5rem;

  p {
    font-size: ${b.fontSize02};
    font-weight: ${b.fontWeight03};
    color: ${b.bg04};
  }

  .loader-text {
    font-size: ${b.fontSize02};
    font-weight: ${b.fontWeight01} !important;
    color: ${b.color08};
  }

  .error-text {
    font-size: ${b.fontSize01};
    color: ${b.color08};
  }

  svg {
    min-width: 24px;
    min-height: 24px;
    fill: ${b.color08};
  }

  .spinner {
    display: block;
    min-width: 24px;
    min-height: 24px;
    border-radius: 100%;
    border-top: 4px solid ${b.colorInfo};
    border-right: 4px solid ${b.colorInfo};
    border-bottom: 4px solid ${b.colorInfo};
    border-left: 4px solid transparent;
    transition: 500ms all;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;function vt(e){return"noticias"===e?"news":e}const wt=C`
  query GetPostStaticContent {
    getPostStaticContent {
      enabled
      seo {
        id
        title
        description
        robots
        url_canonical
      }
    }
  }
`,xt=e=>{var t;const[o,i]=x(!1),{isLogged:n}=(()=>{const e=(new k).get("logged");return{isLogged:w((()=>!!e&&!!e.username),[e])}})(),{getPostStaticContent:r,data:a,loading:l,error:s}=(()=>{const[e,{loading:t,error:o,data:i}]=P(wt,{fetchPolicy:"no-cache"});return{getPostStaticContent:e,loading:t,error:o,data:i}})(),{getFeatureFlag:d,data:c,loading:g,error:u}=tt();return y((()=>{n?(r(),d({variables:{featureName:"newsChannel"}})):i(!1)}),[n]),y((()=>{if(!(l||g||s||u)){const{auxNews:e,auxBlog:t}={auxNews:c&&c.getFeatureFlag&&c.getFeatureFlag[0].enabled||!1,auxBlog:a&&a.getPostStaticContent&&a.getPostStaticContent.enabled||!1};i(!(!t||!e))}}),[a,l,s,c,g,u]),{isEnabled:o,isBlogEnabled:!!(null===(t=null==a?void 0:a.getPostStaticContent)||void 0===t?void 0:t.enabled),isNewsEnabled:!(!(null==c?void 0:c.getFeatureFlag)||!(null==c?void 0:c.getFeatureFlag[0].enabled))}},yt=({pageType:i,hasMoreNewsButton:n=!1,hasFeatureFlagCheck:a=!0,hasShowOrigin:l=!1,content:s,omitID:d,autoplay:c=!0,tagEvents:g})=>{var u,m;const p=r(),{getPostsImages:f,data:h,loading:b,error:v}=(()=>{const e=C`
    query GetPostImages($route: String) {
      getPostImages(route: $route) {
        data {
          id
          codigoAgroLink
          antetitulo
          titulo
          fonte
          assinadoPor
          dataHoraAgroLink
          resumo
          texto
          urlBanner
          urlBannerMobile
          urlMiniatura
          visualizacoes
          disponivelParaLeitura
          disponivelAreaDeslogada
          createdAt
          updatedAt
          slug
          rota
          categoria {
            id
            slug
            titulo
            createdAt
            updatedAt
            disponivelAreaDeslogada
          }
        }
        meta {
          pagination {
            page
            pageSize
            pageCount
            total
          }
        }
      }
    }
  `,[t,{loading:o,error:i,data:n,called:r,refetch:a}]=P(e,{fetchPolicy:"no-cache"});return{getPostsImages:t,loading:o,error:i,data:n,called:r,refetch:a}})(),{isBlogEnabled:$,isNewsEnabled:z}=xt(),{isFeatureEnabled:k}=w((()=>{var e,t,o;if(s){const{data:i,loading:n,error:r}=s;return{isFeatureEnabled:!(!a||n||r||!(null===(o=null===(t=null===(e=null==i?void 0:i.getDashboardDataContent)||void 0===e?void 0:e.newDashboard)||void 0===t?void 0:t.newsPortal)||void 0===o?void 0:o.enabled))}}return{isFeatureEnabled:!a}}),[s,a]);y((()=>{k&&f({variables:{route:vt(i)}})}),[k]);const{min:N,max:T}={min:0,max:(null==h?void 0:h.getPostImages.data)&&h.getPostImages.data.length-1||0},[I,S]=x(N),[F,D]=x("R");function G(e,t){D(e),S(t)}function B(e,t){return"R"===e?(t>T&&(t=N,e="L"),G(e,t)):"L"===e?(t<N&&(t=T,e="R"),G("R",t)):void 0}let M;y((()=>c&&(null==h?void 0:h.getPostImages)&&h.getPostImages.data&&(null==h?void 0:h.getPostImages.data.length)>0?(M=setTimeout((()=>{B("R",(I+1)%(null==h?void 0:h.getPostImages.data.length))}),6e3),()=>clearTimeout(M)):()=>!1),[I,h]),y((()=>{var e;if(h&&h.getPostImages.data&&h.getPostImages.data.length>0)return d&&d((null===(e=h.getPostImages.data[0].id)||void 0===e?void 0:e.toString())||"")}),[h]);const{isMobile:_}=(e=>{const[t,o]=x(!1);return y((()=>{const t=()=>{o(window.innerWidth<=e)};return window.addEventListener("resize",t),()=>window.removeEventListener("resize",t)}),[e]),{isMobile:t}})(680);return k?b?e(bt,{children:[t("span",{className:"spinner"}),t("p",{className:"loader-text",children:"Aguarde, estamos carregando às notícias mais recentes"})]}):v||null===(null==h?void 0:h.getPostImages.data)?e(bt,{children:[t(A,{}),t("span",{className:"error-text",children:"Ocorreu um erro ao carregar as notícias, tente novamente mais tarde"})]}):e(ut,{children:[e(mt,{children:[t("button",{className:"change-news-button left",title:"Notícia anterior",onClick:()=>B("L",I-1),children:t(E,{})}),t("button",{className:"change-news-button right",title:"Próxima notícia",onClick:()=>B("R",I+1),children:t(L,{})}),e("span",{className:"description-container",children:[l&&t("p",{className:"identifier",children:(null===(u=null==h?void 0:h.getPostImages.data[I].rota)||void 0===u?void 0:u.toUpperCase())||""}),t("h2",{className:"description",children:(null===(m=null==h?void 0:h.getPostImages.data[I])||void 0===m?void 0:m.titulo)||""})]}),t(pt,{$slideIndex:I,$dir:F,children:null==h?void 0:h.getPostImages.data.map((e=>t(ht,{src:_?e.urlBannerMobile||e.urlBanner:e.urlBanner||"",title:e.titulo||"",tabIndex:-1,onClick:()=>{var t;return p.push(`/${e.rota}/${null===(t=e.categoria)||void 0===t?void 0:t.slug}/${e.slug}`)}},e.id)))})]}),e(ft,{children:[null==h?void 0:h.getPostImages.data.map(((e,o)=>t("button",{title:`${e.titulo||""}`,className:o===I?"dot-navigator selected":"dot-navigator",onClick:()=>B("R",o)},e.id))),n&&t("button",{className:"more-news-button",title:"Visualizar mais notícias",onClick:()=>{g&&g.onClickAllNews(),p.push(function(e,t){return e&&t||e&&!t?"/blog":"/noticias"}($,z))},children:"Mais notícias"})]})]}):t(o,{})},$t=h.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`,Ct=h.h2`
  display: flex;
  border: none;
  font-size: ${b.fontSize02};
  color: ${b.colorInfo};
  font-weight: ${b.fontWeight03};
  transition: 250ms;
  width: fit-content;
  cursor: pointer;

  :hover {
    text-decoration: underline;
    filter: brightness(0.8);
  }
`,Pt=h.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  font-size: ${b.fontSize01};
  color: ${b.bg01};
  transition: 250ms;
  width: fit-content;
  cursor: pointer;

  margin-top: 1rem;
  margin-bottom: 1rem;

  :hover {
    text-decoration: underline;
    filter: brightness(0.8);
  }

  svg {
    fill: ${b.bg01};
  }
`,zt=h.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h1 {
    font-weight: ${b.fontWeight03};
    font-size: ${b.fontSize14};
  }
`,kt=h.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  font-size: ${b.fontSize12};

  img {
    width: 100%;
    //height: 400px;
    border-radius: 1rem;
    object-fit: cover;
  }

  .responsive-image {
    display: none;
  }

  .detailed-news {
    display: flex;
    flex-direction: column;

    p:not(:last-child) {
      margin-bottom: 0.75rem;
    }
  }

  @media (max-width: 780px) {
    .responsive-image {
      display: block;
    }
    .normal-image {
      display: none;
    }
  }
`,Nt=h.div`
  display: flex;
  flex-direction: column;

  .footer-texts {
    display: flex;
    flex-direction: column;
    gap: 0.225rem;
    color: ${b.color09};
    font-size: ${b.fontSize02};

    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .semi-bold {
    font-weight: ${b.fontWeight03};
  }
`,Tt=h.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border: none;
  outline: none;
  background-color: transparent;
  color: ${b.bg01};
  font-size: ${b.fontSize01};
  font-weight: ${b.fontWeight03};
  gap: 0.5rem;
  transition: 300ms all;
  cursor: pointer;

  svg {
    min-height: 1rem;
    min-width: 1rem;
    fill: ${b.bg01};
  }

  :hover,
  :active {
    text-decoration: underline;
    filter: brightness(0.8);
  }
`,It=({pageType:i,slug:n,category:a,onErrorCallback:l,onLoadingCallback:s,getNewsTitle:d,getNewsResumed:c,onLoadGtm:g})=>{var u,m,p,f,h,b,v,w,x,$,P;const k=r();n||k.push(`/${i}`);const{createNotification:N}=q();const{data:T,loading:I,error:S}=(({category:e,slug:t,route:o})=>{const i=C`
    query GetPostDetails($route: String!, $slug: String, $category: String) {
      getPostDetails(route: $route, slug: $slug, category: $category) {
        id
        codigoAgroLink
        antetitulo
        titulo
        fonte
        dataHoraAgroLink
        resumo
        texto
        urlBanner
        urlBannerMobile
        urlMiniatura
        visualizacoes
        disponivelParaLeitura
        disponivelAreaDeslogada
        createdAt
        updatedAt
        slug
        categoria {
          id
          slug
          titulo
          createdAt
          updatedAt
          disponivelAreaDeslogada
        }
      }
    }
  `,{loading:n,error:r,data:a,refetch:l}=z(i,{variables:{category:e,slug:t,route:o},fetchPolicy:"no-cache"});return{loading:n,error:r,data:a,refetch:l}})({category:a,slug:n,route:i});return d&&d((null===(u=null==T?void 0:T.getPostDetails)||void 0===u?void 0:u.titulo)||""),c&&c((null===(m=null==T?void 0:T.getPostDetails)||void 0===m?void 0:m.resumo)||""),y((()=>{s&&s(I),l&&l(!!S)}),[I,S]),y((()=>{g&&g(a)}),[]),I?t(He,{className:"show",children:t("span",{className:"spinner"})}):e($t,{children:[!S&&(null==T?void 0:T.getPostDetails)?e(o,{children:[e(zt,{children:[t(Ct,{onClick:()=>{var e,t;return k.push(`/${i}/${null===(t=null===(e=null==T?void 0:T.getPostDetails)||void 0===e?void 0:e.categoria)||void 0===t?void 0:t.slug}`)},children:(null===(h=null===(f=null===(p=null==T?void 0:T.getPostDetails)||void 0===p?void 0:p.categoria)||void 0===f?void 0:f.titulo)||void 0===h?void 0:h.toUpperCase())||""}),t("h1",{children:(null===(b=null==T?void 0:T.getPostDetails)||void 0===b?void 0:b.titulo)||""}),e(Pt,{onClick:function(){return nt(this,void 0,void 0,(function*(){yield navigator.clipboard.writeText(location.href),N({kind:"success",title:"Link copiado para área de transferência"})}))},children:[t(G,{}),"Compartilhar"]})]}),e(kt,{children:[t("img",{className:"normal-image",src:(null===(v=null==T?void 0:T.getPostDetails)||void 0===v?void 0:v.urlBanner)||"",alt:a,title:a}),t("img",{className:"responsive-image",src:(null===(w=null==T?void 0:T.getPostDetails)||void 0===w?void 0:w.urlBannerMobile)||T.getPostDetails.urlBanner||"",alt:a,title:a}),t("span",{className:"detailed-news",dangerouslySetInnerHTML:{__html:(null===(x=null==T?void 0:T.getPostDetails)||void 0===x?void 0:x.texto)||""}})]})]}):t(st,{}),e(Nt,{children:[!S&&e("div",{className:"footer-texts",children:[e("p",{children:["Por:"," ",t("span",{className:"semi-bold",children:(F=(null===($=null==T?void 0:T.getPostDetails)||void 0===$?void 0:$.fonte)||"",F?F.charAt(0).toUpperCase()+F.slice(1).toLowerCase():"")})]}),t("p",{children:`Publicado em ${Xe(null===(P=null==T?void 0:T.getPostDetails)||void 0===P?void 0:P.createdAt)||""}`})]}),e(Tt,{onClick:()=>k.push(`/${i}`),children:[t(B,{}),`Voltar para ${i}`]})]})]});var F},St=h.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: fit-content;
  height: fit-content;

  @media (max-width: 672px) {
    width: 100%;
  }
`,Ft=h.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.75rem;
  outline: none;
  font-size: ${b.fontSize01};
  font-weight: ${b.fontWeight03};
  transition: all 0.3s ease;

  svg {
    min-height: 24px;
    min-width: 24px;
  }

  &.left {
    border-radius: 0.5rem 0 0 0.5rem;
  }
  &.right {
    border-radius: 0 0.5rem 0.5rem 0;
  }
  &.inactive {
    color: ${b.bg01};
    background-color: ${b.bg03};
    border: 1px solid ${b.color16};
    svg {
      fill: ${b.bg01};
    }
  }
  &.active {
    color: ${b.bg03};
    background-color: ${b.bg01};
    border: none;
    svg {
      fill: ${b.bg03};
    }
  }

  :hover {
    filter: brightness(0.95);
  }
  :active {
    filter: brightness(0.9);
  }

  cursor: pointer;

  @media (max-width: 672px) {
    padding: 0.225rem 1.75rem;
  }
`,Dt=({pageType:i})=>{const n=r(),{isEnabled:a}=xt();return a?e(St,{children:[e(Ft,{className:"left "+("blog"===i?"active":"inactive"),onClick:()=>n.push("/blog"),children:[t(M,{}),"Blog"]}),e(Ft,{className:"right "+("noticias"===i?"active":"inactive"),onClick:()=>n.push("/noticias"),children:[t(_,{}),"Notícias"]})]}):t(o,{})},At=C`
  query GetBlogSeo {
    getPostStaticContent {
      seo {
        id
        title
        description
        robots
        url_canonical
      }
    }
  }
`,Et=({category:o,title:i,description:n,isCategoryPage:r})=>{var a,l,s,d;const{data:c}=(()=>{const{loading:e,error:t,data:o}=z(At,{fetchPolicy:"no-cache"});return{loading:e,error:t,data:o}})(),[g,u]=x(i),[m,p]=x(n);return y((()=>r||o?!r&&o?(u(`${o} | Os temas mais buscados do agro estão aqui`),void p(`Os assuntos mais buscados sobre ${o} estão no Blog E-agro. Tire todas as suas dúvidas sobre o tema e encontre dicas valiosas para gerenciar sua produção agropecuária`)):i&&n?(u(`${i} | Blog E-agro`),void p(n)):void 0:(u(void 0),void p(void 0))),[o,r,i,n]),e(H,{children:[t("title",{children:g||(null===(a=null==c?void 0:c.getPostStaticContent.seo)||void 0===a?void 0:a.title)}),t("meta",{name:"description",content:m||(null===(l=null==c?void 0:c.getPostStaticContent.seo)||void 0===l?void 0:l.description)}),t("meta",{name:"robots",content:null===(s=null==c?void 0:c.getPostStaticContent.seo)||void 0===s?void 0:s.robots}),t("link",{rel:"canonical",href:null===(d=null==c?void 0:c.getPostStaticContent.seo)||void 0===d?void 0:d.url_canonical})]})},Lt=h.div`
  display: flex;
  flex-direction: column;

  padding: 1rem;

  @media (max-width: 671px) {
    border: none;
    padding: 0;
  }

  @media (min-width: 672px) {
    border: 1px solid ${b.color30};
    border-radius: 0.5rem;
    width: auto;
    /* max-width: 24.12rem; */
    max-width: 100%;
  }
`,Gt=h.div`
  height: 2.5rem;
  width: 2.5rem;

  align-items: center;
  justify-content: center;
  display: flex;

  border-radius: 0.5rem;
  background-color: ${b.colorInfoLight};
  color: ${b.colorInfo};
`,Bt=h.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .category-title {
    font-size: ${b.fontSize12};
    font-weight: ${b.fontWeight03};
    color: ${b.color04};

    @media (max-width: 671px) {
      font-size: ${b.fontSize03};
    }
  }
`,Mt=h.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 672px) {
    border-bottom: 1px solid ${b.color16};
    padding-bottom: 1rem;
  }
`,_t=h.button`
  border: none;
  @media (min-width: 672px) {
    display: none;
  }

  transition: 500ms;

  &.closed {
    transform: rotate(180deg);
  }
`,jt=h.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  margin-top: 1.5rem;
  font-size: 1.125rem;

  h5 {
    cursor: pointer;
    border: none;
    font-size: 1.125rem;
    display: flex;
    justify-content: flex-start;
    font-weight: normal;
  }

  max-height: 100vh;
  transition: 250ms linear;

  .category-link {
    color: ${b.color10};
    text-transform: capitalize;

    :hover {
      text-decoration: underline;
      :hover {
        color: ${b.color01};
      }
    }
  }

  .category-selected {
    background-color: ${b.bg01};
    color: ${b.color03};
    border-radius: 0.875rem;
    font-size: 1rem;
    width: fit-content;
    padding: 0.25rem 1rem;
    text-transform: capitalize;
    transition: 250ms;

    :hover {
      filter: brightness(0.75);
    }
  }

  @media (max-width: 671px) {
    &.hidden {
      line-height: 0;
      opacity: 0;
      gap: 0;
      pointer-events: none;
      margin-top: 0;
      max-height: 0;
    }
  }
`,Wt=C`
  query GetPostCategories($route: String!) {
    getPostCategories(route: $route) {
      id
      slug
      titulo
      createdAt
      updatedAt
      disponivelAreaDeslogada
    }
  }
`,Rt=({pageType:o,selected:i,onErrorCallback:n,onLoadingCallback:a,onChangeCategory:l,onChangeCategoryTitle:s,onClickGtm:d})=>{var c;const{data:g,loading:u,error:m}=(e=>{const{loading:t,error:o,data:i,called:n}=z(Wt,{variables:{route:e},fetchPolicy:"no-cache"});return{loading:t,error:o,data:i,called:n}})(o),p=r();y((()=>{a&&a(u),n&&n(!!m)}),[u,m]),y((()=>{var e,t;if(!u){if(!i)return l&&l(void 0),void(s&&s(""));const o=Number(null===(e=null==g?void 0:g.getPostCategories.find((e=>(null==e?void 0:e.slug)===i)))||void 0===e?void 0:e.id),n=(null===(t=null==g?void 0:g.getPostCategories.find((e=>(null==e?void 0:e.slug)===i)))||void 0===t?void 0:t.titulo)||"";l&&l(o),s&&s(n)}}),[i,u,l,s,g]);const[f,h]=x(!0);return e(Lt,{children:[e(Mt,{children:[e(Bt,{children:[t(Gt,{children:t(j,{})}),t("h4",{className:"category-title",children:"Categorias"})]}),t(_t,{onClick:()=>h(!f),className:f?"":"closed",children:t(W,{})})]}),t(jt,{className:f?"":"hidden",children:null===(c=null==g?void 0:g.getPostCategories)||void 0===c?void 0:c.map(((e,n)=>t("h5",{onClick:()=>{l&&l(parseInt(null==e?void 0:e.id)),d&&d(e.slug),p.push(`/${o}/${e.slug}`)},className:(null==e?void 0:e.slug)===i?"category-selected":"category-link",children:null==e?void 0:e.titulo},n)))})]})},Ot=h.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 0.5rem;

  button {
    font-size: ${b.fontSize01};
    color: ${b.bg01};
    border: none;
    text-transform: capitalize;

    white-space: nowrap;

    cursor: pointer;

    :hover {
      text-decoration: underline;
    }
  }

  .divider {
    font-size: ${b.fontSize01};
  }

  .last-crumb {
    font-size: ${b.fontSize01};
    text-transform: capitalize;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`,qt={newsCrumb:[{route:"/dashboard/dashboardPage",category:"",newsId:"",label:"Início"},{route:"/noticias",category:"",newsId:"",label:"Notícias"}],blogCrumb:[{route:"",category:"",newsId:"",label:"Início"},{route:"/blog",category:"",newsId:"",label:"Blog"}]},Ht=({category:o,categorySlug:i,pageType:n,id:a,title:l})=>{const s=r(),[d,c]=x("blog"===n?qt.blogCrumb:qt.newsCrumb);return y((()=>{const e="blog"===n?[...qt.blogCrumb]:[...qt.newsCrumb];o&&e.push({route:"blog"===n?"/blog":"/noticias",category:i,newsId:a||"",label:o}),a&&e.push({route:"blog"===n?"/blog":"/noticias",category:i,newsId:a,label:l}),c(e)}),[o,a,l]),t(Ot,{children:d&&d.length>0&&d.map(((o,i)=>e(v.Fragment,{children:[i<d.length-1?t("button",{title:o.label,onClick:()=>s.push(`${o.route}/${o.category}`),children:o.label}):t("span",{className:"last-crumb",children:o.label}),i<d.length-1&&t("span",{className:"divider",children:"/"})]},V())))})},Vt=h.div`
  position: absolute;
  height: 247px;
  width: 100%;
  top: 4rem;
  z-index: -1;
  background-image: linear-gradient(180deg, #f2f5ff 0%, #ffffff00 100%);
`,Ut=h.section`
  display: flex;
  width: 100%;
  height: fit-content;
  align-items: center;
  justify-content: center;
`,Yt=h.div`
  display: block;
  margin-top: 2rem;
  margin-bottom: 2rem;

  // Following the same principles of the header:
  @media (min-width: 1312px) {
    width: 78rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 64rem;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    width: 100%;
    padding: 0 1rem;
  }
`,Kt=({children:o})=>e(Ut,{children:[t(Vt,{}),t(Yt,{children:o})]}),Xt=h.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  /* width: fit-content; */
  max-width: 100%;

  padding: 1rem;
  border: 1px solid ${b.color30};
  border-radius: 0.5rem;

  @media (max-width: 671px) {
    border: none;
    padding: 0;
  }
`,Jt=h.div`
  height: 2.5rem;
  width: 2.5rem;

  align-items: center;
  justify-content: center;
  display: flex;

  border-radius: 0.5rem;
  background-color: ${b.colorInfoLight};
  color: ${b.colorInfo};
`,Qt=h.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  margin-bottom: 0.5rem;

  .menu-title {
    font-size: ${b.fontSize12};
    font-weight: ${b.fontWeight03};
    color: ${b.color04};
  }

  @media (max-width: 671px) {
    .menu-title {
      font-size: ${b.fontSize03};
    }
  }
`,Zt=({pageType:o,mostViewed:i,onErrorCallback:n,onLoadingCallback:r,categoryId:a})=>{const{data:l,loading:s,error:d}=(({page:e,pageSize:t,categoryId:o,sort:i,route:n})=>{const{loading:r,error:a,data:l,called:s}=z(it,{variables:{page:e,pageSize:t,categoryId:o,sort:i,route:n},fetchPolicy:"no-cache"});return{loading:r,error:a,data:l,called:s}})({page:1,pageSize:5,categoryId:i?void 0:a,sort:i?{visualizacoes:"DESC"}:{},route:o});return y((()=>{r&&r(s),n&&n(!!d)}),[s,d]),e(Xt,{children:[e(Qt,{children:[t(Jt,{children:t(i?R:O,{})}),t("span",{className:"menu-title",children:i?"Notícias mais lidas":"Notícias similares"})]}),(null==l?void 0:l.getPosts.data)&&l.getPosts.data.length>0&&(null==l?void 0:l.getPosts.data.map(((e,i)=>t(Je,{news:e,pageType:o},i))))]})},eo=()=>{const{category:i,slug:n}=l(),a=r(),{getPosts:s,data:d,loading:c,error:g,called:m}=(()=>{const[e,{loading:t,error:o,data:i,called:n}]=P(it,{fetchPolicy:"no-cache"});return{getPosts:e,loading:t,error:o,data:i,called:n}})(),{onGetOmittID:p,blogOrNewsHandler:{pageTitle:f,pageType:h},mainPageActions:{isFeatureFlagEnabled:b,isFeatureFlagLoading:v,isFeatureFlagCalled:w,states:{hasError:x,isLoading:$},onLoadMoreNews:C,getNewsComponent:z},pageElementsHandler:{hasCarousel:k,hasDetailedNews:N,hasCategoryFiltered:T,hasMoreNewsButton:I,hasNewsletter:S},pageActionHandler:{breadcrumb:{breadcrumbTitle:F,setBreadcrumbTitle:D},resumed:{newsResumed:A,setNewsResumed:E},category:{id:{categoryID:L,setCategoryID:G},title:{categoryTitle:B,setCategoryTitle:M}}},pageCallbackHandlers:{details:{loading:{setDetailsLoading:_},error:{setDetailsError:j}},similar:{loading:{setSimilarLoading:W},error:{setSimilarError:R}},categories:{loading:{setCategoriesLoading:O},error:{setCategoriesError:q}}}}=ot({category:i,slug:n,getPosts:{data:d,loading:c,error:g,called:m,getPosts:s}}),{callTagManager:H}=at("blog"===h?lt.blog:lt.news);return y((()=>{i||n||H("pageLoad")}),[i,n]),y((()=>{b&&s({variables:{page:1,pageSize:5,route:h}})}),[b]),v?t(He,{className:"show",children:t("span",{className:"spinner"})}):w&&!b?(a.push("/not-found"),t(o,{})):e(Kt,{children:["blog"===h&&t(Et,{title:F,category:B,description:A,isCategoryPage:N}),e(He,{className:$?"show":"",children:[t("span",{className:"spinner"}),t("p",{children:"Aguarde, às notícias estão sendo carregadas"})]}),t(Ht,{category:B||"",categorySlug:i||"",id:n||"",title:F,pageType:h}),e(Ve,{children:[t(T||N?Be:Ge,{children:f}),k&&t(Dt,{pageType:h})]}),e(Le,{children:[x?t(st,{}):e(o,{children:[(k||!N)&&e(Me,{children:[k&&t(yt,{hasFeatureFlagCheck:!1,pageType:h,omitID:p}),!N&&!x&&e(We,{children:[T?e("h1",{className:"main-title",children:["Categoria:"," ",t(_e,{children:B})]}):t("h2",{className:"main-title",children:"Publicados recentemente"}),!c&&!g&&z(),I&&t(u,{className:"more-news-button",label:"Ver mais",size:"large",variant:"primary",onClick:()=>{C(),H("loadMoreNews")},disabled:$})]})]}),!x&&!c&&N&&n&&i&&t(It,{pageType:h,slug:n,category:i,getNewsTitle:D,getNewsResumed:E,onErrorCallback:j,onLoadingCallback:_,onLoadGtm:e=>H("detailsLoad",void 0,e)})]}),t(Re,{}),e(je,{children:[t(Zt,{pageType:h,mostViewed:!N&&!g,categoryId:L,onErrorCallback:R,onLoadingCallback:W}),t(Re,{}),t(Rt,{pageType:h,selected:(V=i,V?V.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase():""),onChangeCategory:G,onErrorCallback:q,onLoadingCallback:O,onChangeCategoryTitle:M,onClickGtm:e=>H("categoryClick",e)}),t(Oe,{}),S&&t(gt,{onClickGtm:()=>H("newsletterClick")})]})]})]});var V},to=()=>e(f,{prefix:"/blog",missing:m,children:[t(s,{path:"/blog/:category?/:slug?",component:eo}),t(s,{path:"/not-found",component:m})]}),oo=e=>{var{children:o}=e,i=function(e,t){var o={};for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.indexOf(i)<0&&(o[i]=e[i]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(i=Object.getOwnPropertySymbols(e);n<i.length;n++)t.indexOf(i[n])<0&&Object.prototype.propertyIsEnumerable.call(e,i[n])&&(o[i[n]]=e[i[n]])}return o}(e,["children"]);return t(p,Object.assign({},i,{children:o}))};Ee.polyfill();const io=({config:e,children:o})=>{const r=e.appWrapper;return t(r,{config:e,children:t(i,{config:n(e),render:e=>t(oo,Object.assign({},e,{children:null!=o?o:t(to,{})}))})})};export{io as default};
//# sourceMappingURL=bundle.esm.js.map
